import React from 'react';

export interface ForumUserWithAvatar {
  profile_picture_url?: string | null;
  display_name: string;
}

export function UserAvatar({ user, size = 28 }: { user: ForumUserWithAvatar; size?: number }) {
  const style = { width: size, height: size, borderRadius: '50%', objectFit: 'cover' as const };
  if (user.profile_picture_url) {
    return <img src={user.profile_picture_url} alt="" style={style} className="community-user-avatar" />;
  }
  return (
    <span className="community-user-avatar community-user-avatar-default" style={{ width: size, height: size }}>
      <i className="fas fa-user" aria-hidden />
    </span>
  );
}
